import * as React from 'react';

import './spinner.css';

// TODO: if needed in the future, allow customisable size
class Spinner extends React.Component {
  public render() {
    const wrapperClasses = 'column is-12 has-text-centered spinner-wrapper'
    
    return (
      <div className={wrapperClasses}>
        <span className="spinner" />
      </div>
    );
  }
}

export default Spinner;


// WEBPACK FOOTER //
// ./src/common/spinner/Spinner.tsx